export default __webpack_public_path__ + "static/media/Ethel with Fred Bremer all 6 kids and unknown person.b6077409.jpg";